import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IEvent, IEventsPagination } from '@interfaces/IEvent';
import { IEventsQParams } from '@interfaces/IEventsQParams';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EventsViewService {
  constructor(private _http: HttpClient) {}

  get(qParams: IEventsQParams): Observable<IEventsPagination> {
    const url = `${environment.baseUrl}api/v1/events/`;
    let params = new HttpParams();

    Object.entries(qParams).forEach(param => {
      params = params.set(param[0], param[1]);
    });

    return this._http.get<IEventsPagination>(url, { params });
  }

  getById(id: number): Observable<IEvent> {
    const url = `${environment.baseUrl}api/v1/events/${id}/`;
    return this._http.get<IEvent>(url);
  }

  getByPeriod(period_id: number): Observable<IEvent[]> {
    const url = `${environment.baseUrl}api/v1/periods/${period_id}/events/`;
    return this._http.get<IEvent[]>(url);
  }
  getVideoLink(event_id: number) {
    const url = `${environment.baseUrl}api/v1/events/${event_id}/upload_to_s3/`;
    return this._http.get(url);
  }
}
